'use client';

import { KeyTextField } from '@prismicio/client';
import { useEffect, useRef, useState } from 'react';
import styles from './Switcher.module.scss';

interface Props {
  switcher: KeyTextField[];
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}

const Switcher = ({ switcher, activeTab, setActiveTab }: Props) => {
  const [indicatorStyle, setIndicatorStyle] = useState({
    width: '0px',
    left: '0px',
  });
  const tabRefs = useRef<(HTMLLIElement | null)[]>([]);
  const switcherRef = useRef<HTMLDivElement>(null);

  const activeIndex = activeTab;

  const handleSwitchTabs = (index: number) => {
    if (index === activeTab) return;
    setActiveTab(index);
  };

  useEffect(() => {
    const updateIndicator = () => {
      if (activeIndex !== -1 && tabRefs.current[activeIndex]) {
        const activeTabElement = tabRefs.current[activeIndex];
        const tabWidth = activeTabElement?.offsetWidth || 0;
        const tabLeft = activeTabElement?.offsetLeft || 0;

        setIndicatorStyle({
          width: `${tabWidth}px`,
          left: `${tabLeft}px`,
        });
      }
    };

    const resizeObserver = new ResizeObserver(updateIndicator);

    if (switcherRef.current) {
      resizeObserver.observe(switcherRef.current);
    }

    tabRefs.current.forEach((tab) => {
      if (tab) resizeObserver.observe(tab);
    });

    return () => {
      resizeObserver.disconnect();
    };
  }, [activeIndex, switcher]);

  return (
    <div ref={switcherRef} className={styles.tabsContainer}>
      <ul className={styles.tabs}>
        {switcher.map((tab, index) => (
          <li
            ref={(el) => {
              tabRefs.current[index] = el;
            }}
            className={`${activeTab === index ? styles.tabActive : styles.tab}`}
            onClick={() => handleSwitchTabs(index)}
            key={tab}
          >
            <p className={styles.tabText}>{tab}</p>
          </li>
        ))}
        <span
          style={{
            ...indicatorStyle,
          }}
          className={styles.indicator}
          aria-hidden="true"
        />
      </ul>
    </div>
  );
};

export default Switcher;
